export const ADD_POS_ORDER = 'ADD_POS_ORDER';
export const UPDATE_POS_ORDER = 'UPDATE_POS_ORDER';
export const REMOVE_POS_ORDER = 'REMOVE_POS_ORDER';
export const REMOVE_POS_ORDER_BY_ORDERCODE = 'REMOVE_POS_ORDER_BY_ORDERCODE';
export const REMOVE_POS_ORDER_ALL = 'REMOVE_POS_ORDER_ALL';

export const ADD_WAITING_ORDER = 'ADD_WAITING_ORDER';
export const UPDATE_WAITING_ORDER = 'UPDATE_WAITING_ORDER';
export const REMOVE_WAITING_ORDER = 'REMOVE_WAITING_ORDER';
export const REMOVE_WAITING_ORDER_BY_ORDERCODE =
  'REMOVE_WAITING_ORDER_BY_ORDERCODE';
export const REMOVE_WAITING_ORDER_ALL = 'REMOVE_WAITING_ORDER_ALL';
export const REMOVE_WAITING_ORDER_BY_ORDER_AWAIT_ID =
  'REMOVE_WAITING_ORDER_BY_ORDER_AWAIT_ID';

export const ADD_ORDER_INFO = 'ADD_ORDER_INFO';
export const REMOVE_ORDER_INFO = 'REMOVE_ORDER_INFO';
export const REMOVE_ORDER_INFO_ALL = 'REMOVE_ORDER_INFO_ALL';

export const SET_KEYBOARD_SETTING = 'CHANGE_KEYBOARD_SETTING';

export const SET_VOLUME_SETTING = 'SET_VOLUME_SETTING';

export const REMOVE_OLD_POS_ORDER = 'REMOVE_OLD_POS_ORDER';
export const REMOVE_OLD_WAITING_ORDER = 'REMOVE_OLD_WAITING_ORDER';

export const SET_MULTI_POS_SETTING = 'SET_MULTI_POS_SETTING';

export const REMOVE_POS_ORDER_BY_ORDER_AWAIT_ID =
  'REMOVE_POS_ORDER_BY_ORDER_AWAIT_ID';

// export const SET_ORDER_STATUS_TABLE_SETTING = "SET_ORDER_STATUS_TABLE_SETTING";

export const addPosOrder = (order, noSave) => ({
  type: ADD_POS_ORDER,
  order: order,
  noSave,
});

export const updatePosOrder = (order, noSave) => ({
  type: UPDATE_POS_ORDER,
  order: order,
  noSave,
});

export const removePosOrder = (idx, noSave) => ({
  type: REMOVE_POS_ORDER,
  idx: idx,
  noSave,
});
export const removePosOrderByOrderCode = (orderCode, noSave) => ({
  type: REMOVE_POS_ORDER_BY_ORDERCODE,
  orderCode: orderCode,
  noSave,
});
export const removePosOrderAll = (noSave) => ({
  type: REMOVE_POS_ORDER_ALL,
  noSave,
});

export const addWaitingOrder = (order, noSave) => ({
  type: ADD_WAITING_ORDER,
  order: order,
  noSave,
});

export const updateWaitingOrder = (order, noSave) => ({
  type: UPDATE_WAITING_ORDER,
  order: order,
  noSave,
});

export const removeWaitingOrder = (idx, noSave) => ({
  type: REMOVE_WAITING_ORDER,
  idx: idx,
  noSave,
});

export const removeWaitingOrderByOrderAwaitId = (id, noSave) => ({
  type: REMOVE_WAITING_ORDER_BY_ORDER_AWAIT_ID,
  id,
  noSave,
});

export const removePosOrderByOrderAwaitId = (id, noSave) => ({
  type: REMOVE_POS_ORDER_BY_ORDER_AWAIT_ID,
  id,
  noSave,
});

export const removeWaitingOrderByOrderCode = (orderCode, noSave) => ({
  type: REMOVE_WAITING_ORDER_BY_ORDERCODE,
  orderCode: orderCode,
  noSave,
});
export const removeWaitingOrderAll = (noSave) => ({
  type: REMOVE_WAITING_ORDER_ALL,
  noSave,
});

export const addOrderInfo = (info, noSave) => ({
  type: ADD_ORDER_INFO,
  info,
  noSave,
});

export const removeOrderInfo = (id, noSave) => ({
  type: REMOVE_ORDER_INFO,
  id: id,
  noSave,
});
export const removeOrderInfoAll = (noSave) => ({
  type: REMOVE_ORDER_INFO_ALL,
  noSave,
});

export const setKeyboardSetting = (keyboardSetting, noSave) => ({
  type: SET_KEYBOARD_SETTING,
  keyboardSetting,
  noSave,
});

export const setVolumeSetting = (volume, noSave) => ({
  type: SET_VOLUME_SETTING,
  volume,
  noSave,
});

export const removeOldPosOrder = (noSave) => ({
  type: REMOVE_OLD_POS_ORDER,
  noSave,
});

export const removeOldWaitingOrder = (noSave) => ({
  type: REMOVE_OLD_WAITING_ORDER,
  noSave,
});

export const setMultiPosSetting = (multiPosSetting, noSave) => ({
  type: SET_MULTI_POS_SETTING,
  multiPosSetting,
  noSave,
});

// export const setOrderStatusTableSetting = (orderStatusTable, noSave) => ({
//   type: SET_ORDER_STATUS_TABLE_SETTING,
//   orderStatusTable,
//   noSave,
// });
